module.exports = __webpack_public_path__ + "img/2.a4ba7304.jpg";